import { createIntlCache, IntlCache } from 'react-intl';

// Explicit typing fixes the issue:
// The inferred type of 'intlCache' cannot be named without a reference to '.pnpm/@formatjs+intl@2.4.1/node_modules/@formatjs/intl/src/types'. This is likely not portable. A type annotation is necessary.
export const intlCache: IntlCache = createIntlCache();
